import { render } from "./AuthFormLogin.vue?vue&type=template&id=590219a5&scoped=true"
import script from "./AuthFormLogin.vue?vue&type=script&lang=ts"
export * from "./AuthFormLogin.vue?vue&type=script&lang=ts"

import "./AuthFormLogin.vue?vue&type=style&index=0&id=590219a5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-590219a5"

export default script